import(/* webpackMode: "eager", webpackExports: ["EventsClient"] */ "/opt/buildhome/repo/src/components/events/events-client.tsx");
